import React from 'react';
import { useTranslation } from 'react-i18next';
import { Product } from '../../../models/Product';

export const CollectionProductImage: React.FC<{
    product: Product;
}> = (props) => {
    const { product } = props;
    const { t } = useTranslation();

    return (
        <>
            <img
                src={
                    product.featuredImage
                        ? product.featuredImage.src
                        : '/assets/no-image_200x.webp'
                }
                alt={
                    product.featuredImage && product.featuredImage.altText
                        ? product.featuredImage.altText
                        : product.title
                }
            />
        </>
    );
};
